import { render, staticRenderFns } from "./UserWrapper.vue?vue&type=template&id=1b00a48a&scoped=true"
import script from "./UserWrapper.vue?vue&type=script&lang=js"
export * from "./UserWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00a48a",
  null
  
)

export default component.exports